///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { Fragment, useEffect, useRef } from "react";

import messages from "../helpers/messages";
import { order } from "../helpers/types";
import Arrow from "./icons/Arrow";

const HeaderCell = ({
  label,
  maxWidth,
  minWidth,
  fieldName,
  sortBids,
  sortField,
  sortOrder,
  sortReverse,
  arrowLeft = false,
  isFetching = false,
  className = "px-8 py-12",
  isFilter = false,
  filter: Filter,
  resize = false,
  columnWidth,
  setColumnWidth,
  checkbox = false,
  checkboxDisabled = false,
  showIndeterminateCheckbox = false,
  checked = false,
  handleCheckboxClick,
  hideLabel = false,
  draggable = false,
  onDragStart,
  onDragEnd,
  onDrop,
  onDragOver
}) => {
  const ArrowIcon = () => (
    <Fragment>
      {fieldName && sortField === fieldName && (
        <Arrow
          className="sort-icon"
          width="24px"
          height="12px"
          title={messages.sort.defaultMessage}
          rotateDegree={sortOrder === order.ascending ? 180 : 0}
        />
      )}
    </Fragment>
  );

  const resizeDivRef = useRef(null);

  useEffect(() => {
    let indeterminateCheckbox = document.getElementById("header-checkbox");
    if (indeterminateCheckbox) {
      indeterminateCheckbox.indeterminate = showIndeterminateCheckbox;
    }
  }, [showIndeterminateCheckbox]);

  return (
    <th
      className={`header-cell ${
        fieldName && !isFetching && !setColumnWidth && "pointer"
      } ${className} ${sortField === fieldName && "sorted-header"}`}
      style={{ maxWidth, minWidth, width: columnWidth }}
      onClick={() =>
        !setColumnWidth &&
        fieldName &&
        !isFetching &&
        sortBids({ fieldName, sortReverse })
      }
      id={fieldName}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDrop={onDrop}
      onDragOver={onDragOver}
    >
      <div className="header-div one-whole">
        <div
          ref={resizeDivRef}
          className={`${resize ? "resizable" : ""} ${
            setColumnWidth || hideLabel ? "pl-8 pr-0 py-12" : ""
          } ${checkbox ? "py-8 mt-4 pl-16" : ""}`}
          onMouseUp={() =>
            setColumnWidth && setColumnWidth(resizeDivRef.current.offsetWidth)
          }
          style={{ width: columnWidth }}
        >
          {arrowLeft && <ArrowIcon />}
          {label && (
            <span
              className={`
                ${setColumnWidth && fieldName && !isFetching ? "pointer" : ""}
                ${hideLabel ? "invisible" : ""}
              `}
              onClick={() =>
                setColumnWidth &&
                fieldName &&
                !isFetching &&
                sortBids({ fieldName, sortReverse })
              }
              onMouseUp={e => e.stopPropagation()}
            >
              {label}
            </span>
          )}
          {checkbox && (
            <input
              id="header-checkbox"
              type="checkbox"
              className={!isFetching && !checkboxDisabled ? "pointer" : ""}
              disabled={isFetching || checkboxDisabled}
              onChange={handleCheckboxClick}
              checked={checked}
            />
          )}
          {!arrowLeft && <ArrowIcon />}
          {isFilter && <Filter label={label} fieldName={fieldName} />}
        </div>
      </div>
    </th>
  );
};

export default HeaderCell;
